import jwt_decode from "jwt-decode";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const TokenHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, setWallets, setAccounts,setHasNewNotification } = useContext(AuthContext);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const refreshToken = params.get("refresh_token");
    if (token && refreshToken) {
      try {
        localStorage.setItem("token", token);
        localStorage.setItem("refresh_token", refreshToken);

        const decoded = jwt_decode(token);
        setUser(decoded);
        setWallets(null);
        setAccounts([]);
        setHasNewNotification(false)

        // Optional: Clean query params
        navigate("/dashboard", { replace: true });
      } catch (err) {
        console.error("Invalid token received:", err.message);
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
      }
    }
  }, [location.search, navigate]);

  return null; // doesn't render anything
};

export default TokenHandler;
